module.exports = __webpack_public_path__ + "static/reimagining-masculinity-thumbnail-c6359e809096947cce273bc9ca671cd4.png";